<template>
  <div class="orders">
    <div class="orderMain">
      <div class="infosearch">        
        <span class="labelTit">下单时间</span>
        <el-date-picker
          v-model="orderTime"
          type="month"
          align="right"
          unlink-panels
          value-format='yyyy-MM'
          style="width: 150px;margin-right: 10px"
        ></el-date-picker>
        <span class="labelTit">员工姓名</span>
        <el-select v-model="keyName" placeholder="请选择员工" style="width:150px;margin-right: 10px">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(i,index) in staffSList" :key="'staffList-'+index" :label="i.staffName" :value='i.staffId'></el-option>
        </el-select>
        <el-button
          class="searchBtn"
          @click="search(1)"
          v-loading.fullscreen.lock="fullscreenLoading"
        ></el-button>
        <!-- <el-button class="darkBtn" @click="outportExcel">导出</el-button> -->
      </div>
      <div class="red" style="margin-top:10px">注：退款金额已在销售业绩中扣除</div>
      <el-table
        v-if="tableData.length > 0"
        :data="tableData"
        ref="multipleTable"
        :cell-class-name="tableRowClassName"
        class="myMemTable"
        style="width: 100%"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column align="center" prop="staffName" label="员工">
          <template slot-scope="scope">
            {{computedStaff(scope.row.staffName,scope.row.staffId,1) | filterRow}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="postId" label="岗位">
          <template slot-scope="scope">
            {{computedStaff(scope.row.postId,scope.row.staffId,2) | filterRow}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="productRealAmount" label="零售销售业绩"></el-table-column>
        <el-table-column align="center" prop="serviceRealAmount" label="服务销售业绩"></el-table-column>
        <el-table-column align="center" prop="serviceUseAmount" label="服务消耗业绩" v-if="$store.state.userInfo.brandId == 1"></el-table-column>
        <template v-else>
            <el-table-column align="center" prop="chargeSaleAmount" label="充值业绩"></el-table-column>
            <el-table-column align="center" prop="serviceUseCount" label="服务次数"></el-table-column>
        </template>
        <el-table-column align="center" prop="manualFee" label="手工费"></el-table-column>
        <el-table-column align="center" prop="toHomeFee" label="上门费" v-if="$store.state.userInfo.brandId == 1"></el-table-column>
        <el-table-column align="center" prop="productRefundAmount" label="是否退款">
          <template slot-scope="scope">
            {{(Number(scope.row.productRefundAmount)+Number(scope.row.serviceRefundAmount)) > 0 ?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="totalFee" label="提成合计"></el-table-column>
        <el-table-column align="center" label="操作" class-name="operation">
            <template slot-scope="scope">
                <el-button size="mini" @click="toView(scope.row)">查看</el-button>
            </template>
        </el-table-column>
      </el-table>
      <template v-else>
        <div class="emptys">查不到提成费用汇总（个人）信息！再核对一下试试</div>
      </template>

    </div>
  </div>
</template>
<script type="text/javascript">
import { formatDate} from '@/components/common/js/date.js';
import { allStaff, queryStaffFee } from "@/api";
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      staffSList:'',
      keyName: "",
      infolist:infolist,
      orderTime:formatDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),'yyyy-MM'),
      tableData: [],
      mySearchflag: false,
      fullscreenLoading: false,
    };
  },
  created() {
    if(this.$store.state.alivePage.flag){
      this.orderTime = this.$store.state.alivePage.yearMonth;
      this.keyName = this.$store.state.alivePage.staffId;
    }
    this.staffList();
    this.search();
    this.$store.commit("setAlivePage", 1);//取消页码状态
  },
  computed: {
    computedStaff(){
      return (val,id,type)=>{
        // type 1是姓名2岗位
        if(!val){
          if(this.staffSList){
            for(let i of this.staffSList){
              if(i.staffId == id){
                return type == 1 ? i.staffName : vFilter.filterPostId(i.postId,this.infolist.postIdData)
              }
            }
          }
        }else{
          return type == 1 ? val:vFilter.filterPostId(val,this.infolist.postIdData)
        }
      }
    }
  },
  methods: {
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      if (rowIndex % 2 == 1) {
        return "highLight";
      }
      return "";
    },
    specialCharacter() {
      this.keyName = this.keyName.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
    },
    staffList(){
      allStaff({
        status:'1'
      }).then(res=>{
        this.staffSList = res.data;
      })
    },
    async search(val) {
      if(!this.orderTime || this.orderTime == ''){
        this.$message({
          message: '请选择下单时间！',
          type: 'error'
        });
        return
      }
      this.fullscreenLoading = true;
      let res = await queryStaffFee({
        yearMonth:this.orderTime?this.orderTime:null,
        staffId:this.keyName ? this.keyName : null
      });
      this.fullscreenLoading = false;
      if(res.code == 0){
        this.$message({
          message: res.msg,
          type: 'error'
        });
        return;
      }
      if (res.data && res.data.length == 0) {
        this.mySearchflag = true;
      }
      this.tableData = res.data?res.data:[];
    },
    toView(row){
      this.$store.commit('setRoyaltyData',{staffName:this.computedStaff(row.staffName,row.staffId,1),storeFeeDTOS:row.storeFeeDTOS,type:1});
      this.$router.push("/financeManageCenter/summaryDetail");
      this.$store.commit('setAlivePage',{yearMonth:this.orderTime,staffId:this.keyName,flag:true})
    },
    outportExcel(){
      if(!this.orderTime || this.orderTime == ''){
        this.$message({
          message: '请选择下单时间！',
          type: 'error'
        });
        return
      }
        let postData = {
        yearMonth:this.orderTime?this.orderTime:null,
        staffId:this.keyName ? this.keyName : null
      }
      this.$http.post(exportSaleOrderList, postData, {
        headers:{
          userId:this.$store.state.userInfo.redisKey
        },
        responseType: "blob"
      })
      .then(res => {      
        if(res.data.type == "application/json"){
          this.$message({
            message: '无提成费用汇总（个人）信息！',
            type: 'error'
          });
          return
        }  
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
        const fileName = '提成费用汇总（个人）.xls';
        if('msSaveOrOpenBlob' in navigator){
            navigator.msSaveOrOpenBlob(blob, '提成费用汇总（个人）.xls');
            return;
        }
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        }else{
          navigator.msSaveBlob(blob, fileName);
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.orderMain {
  padding: 25px 0;
  .labelTit {
    color: #666;
    margin-right: 5px;
  }
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.orderMain {
  .el-date-editor .el-range-separator {
    width: 26px;
  }
}
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/businessManagementCenter/royaltyPersonSum.vue